import React from "react";
import { LoadioContentProfileArtistsTemplate } from "themes/administration/loadio/pages";
import { LoadioContentProfileArtistsViewStore } from "administration/loadio/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new LoadioContentProfileArtistsViewStore(rootStore, componentProps),
    "loadioContentProfileArtistsViewStore"
)
class LoadioContentProfileArtists extends React.Component {
    render() {
        return <LoadioContentProfileArtistsTemplate {...this.props} />;
    }
}

export default LoadioContentProfileArtists;
